<script>
import HorizontalTopbar from "@/components/horizontal-topbar";
// import HorizontalNav from "@/components/horizontal-nav";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";
import MobileFooter from "@/components/mobile-login-footer"

import NprogressContainer from 'vue-nprogress/src/NprogressContainer'

import { layoutComputed } from "@/state/helpers";

/**
 * Horizontal-layout
 */
export default {
  components: {
    HorizontalTopbar,
    // HorizontalNav,
    Footer,
    MobileFooter,
    NprogressContainer,
    RightBar
  },
  data() {
    return {

      attendants: [
      {
        app: 'whatsapp',
        label: 'Service Client',
        name: 'HA - Service Clients',
        number: '%2B21698116113',
        avatar: {
          src: require('@/assets/images/logo.png'),
          alt: 'HA - Service Clients'
        }
      },
    ]

    };
  },
  computed: {
    ...layoutComputed,
  },
  created: () => {
    document.body.setAttribute("data-layout", "horizontal");
    document.body.setAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-sidebar");
    document.body.removeAttribute("data-layout-size");
    document.body.classList.remove("auth-body-bg");
  },
  methods: {
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
      
    document.body.style.background=  this.$route.name === 'default';
    
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
};
</script>

<style lang="scss">
  
  #nprogress .bar {
    background: #f14c31;// #f2b44d;
    height: 4px;
  }

  #nprogress .spinner-icon {
  border: solid 4px transparent;
  border-top-color: #f14c31;
  border-left-color: #f14c31;
  }

  #nprogress .peg {
  box-shadow: 0 0 10px grey, 0 0 5px grey;
  //box-shadow: 0 0 10px #f46a6a, 0 0 5px #f46a6a;
  opacity: 1.0;
  }

  @media all and (max-width: 500px) {
    .container-fluid {
        padding-left: 10px !important;
        padding-right: 10px !important;
    } 
  }

  @media all and (min-width: 501) and (max-width: 1024px) {
    .container-fluid {
        padding-left: 20px !important;
        padding-right: 20px !important;
    } 
  }

</style>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <!-- Begin page -->
    <div id="layout-wrapper">
      <HorizontalTopbar :type="topbar" :width="layoutWidth"  />
      <!-- <HorizontalNav /> -->
      <vue-snotify></vue-snotify>
      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div class="main-content">
        <div class="page-content nprogress-container" :class="this.$route.name === 'default' ? 'page-content-full-width' : 'page-content'">
        <nprogress-container></nprogress-container>
        <!-- Start Content-->
        <div id="containerfluid" :class="this.$route.name === 'default' ? 'container-fluid-full-width' : 'container-fluid'">
          <slot />
          </div>
        </div>
        <!-- End Page-content -->
        <Footer />
        <MobileFooter />
      </div>
      <!-- end main content-->
    </div>
    <!-- END layout-wrapper -->
    <RightBar />

    <SocialChat class="d-print-none"
      icon
      :attendants="attendants"
    >
      <p slot="header">Contacter votre service clients avec whatsapp, disponible tous les jours de 8h à 17h !</p>
      <template v-slot:button>
        <img
        src="@/assets/icons/whatsapp.svg"
          alt="icon whatsapp"
          aria-hidden="true"
        >      
      </template>
      <small slot="footer">Disponible tous les jours de 8h à 17h</small>
    </SocialChat>

  </div>

</template>